import { getId, getEntryUrlContext, getFormContext, getChatflowContext, getConnectedObjectSourceId, getConnectedAccountContext, getForwardedEmailContext, getCustomContext
// @ts-expect-error module not typed
} from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import ChatflowContextSystemUpdate from './ChatflowContextSystemUpdate';
import FormContextSystemUpdate from './FormContextSystemUpdate';
import ConnectedAccountContextSystemUpdate from './ConnectedAccountContextSystemUpdate';
import ForwardedEmailContextSystemUpdate from './ForwardedEmailContextSystemUpdate';
import EntryUrlContextSystemUpdate from './EntryUrlContextSystemUpdate';
import CustomContextSystemUpdate from './CustomContextSystemUpdate';
import { isFacebookMessengerGenericChannel } from '../../operators/isFacebookMessengerGenericChannel';
import { jsx as _jsx } from "react/jsx-runtime";
const ContextUpdateMessage = ({
  inboxId,
  message,
  genericChannelId
}) => {
  const renderEntryUrl = () => {
    return /*#__PURE__*/_jsx(EntryUrlContextSystemUpdate, {
      message: message
    });
  };
  const renderConnectedAccount = () => {
    return /*#__PURE__*/_jsx(ConnectedAccountContextSystemUpdate, {
      inboxId: inboxId,
      message: message
    });
  };
  const renderForwardedEmail = () => {
    return /*#__PURE__*/_jsx(ForwardedEmailContextSystemUpdate, {
      inboxId: inboxId,
      message: message
    });
  };
  const renderCustomContextUpdate = () => {
    return /*#__PURE__*/_jsx(CustomContextSystemUpdate, {
      message: message
    });
  };
  const renderChatFlow = () => {
    const chatflowId = getId(getChatflowContext(message));
    const isFacebookChatflow = isFacebookMessengerGenericChannel(genericChannelId);
    return /*#__PURE__*/_jsx(ChatflowContextSystemUpdate, {
      chatflowId: chatflowId,
      message: message,
      isFacebookChatflow: isFacebookChatflow
    });
  };
  const renderFormMessage = () => {
    const formId = getConnectedObjectSourceId(getFormContext(message));
    return /*#__PURE__*/_jsx(FormContextSystemUpdate, {
      formId: formId,
      inboxId: inboxId,
      message: message
    });
  };
  const renderMessageType = () => {
    const entryUrl = getEntryUrlContext(message);
    const form = getFormContext(message);
    const chatflow = getChatflowContext(message);
    const connectedAccount = getConnectedAccountContext(message);
    const forwardedEmail = getForwardedEmailContext(message);
    const custom = getCustomContext(message);
    if (form) {
      return renderFormMessage();
    }
    if (chatflow) {
      return renderChatFlow();
    }
    if (forwardedEmail) {
      return renderForwardedEmail();
    }
    if (connectedAccount) {
      return renderConnectedAccount();
    }
    if (entryUrl) {
      return renderEntryUrl();
    }
    if (custom) {
      return renderCustomContextUpdate();
    }
    return null;
  };
  const contextUpdateSystemUpdate = renderMessageType() && /*#__PURE__*/_jsx("div", {
    children: renderMessageType()
  });
  return contextUpdateSystemUpdate;
};
ContextUpdateMessage.displayName = 'ContextUpdateMessage';
export default ContextUpdateMessage;